import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import styles from '../index.css';

const Vote = props => {
    const { voteNum, onClose, doGo } = props;
    const [num, setNum] = useState(1);

    const minus = () => {
        const newNum = parseInt(num) - 1 < 1 ? 1 : parseInt(num) - 1;

        setNum(newNum);
    };

    const add = () => {
        const newNum = parseInt(num) + 1 > voteNum ? voteNum : parseInt(num) + 1;

        setNum(newNum);
    };

    const handleOnChange = e => {
        e.preventDefault();
        const { value } = e.target;

        const voteInput = document.getElementById('voteInput');

        voteInput.value = value.replace(/[^\d]/, '');
        if (Number(voteInput.value) >= voteNum) {
            voteInput.value = voteNum;
        }
        if (!voteInput.value || !Number(voteInput.value)) {
            voteInput.value = 1;
        }
        setNum(Number(voteInput.value));
    };

    const handleOnKeyDown = e => {
        e.preventDefault();
        const { value } = e.target;

        const voteInput = document.getElementById('voteInput');

        voteInput.value = value.replace(/[^\d]/, '');
        const strLength = value.length;

        if (e.keyCode === 8) {
            if (e.target.value.length === 1) {
                voteInput.value = '';
                setNum(voteInput.value);
            }

            for (let i = strLength; i > 0; i--) {
                voteInput.value = value.slice(0, i - 1);
                setNum(voteInput.value);
            }
        }
    };

    const handleClick = () => {
        if (!num) {
            return;
        }
        doGo(parseInt(num));
    };

    return (
        <Modal isOpen={true} onCancel={onClose}>
            <div className={styles.voteContainer}>
                <div className={styles.input}>
                    <span className={`${num === 1 || !num ? styles.disable : ''} ${styles.jian}`} onClick={minus}>
                        －
                    </span>
                    <input
                        className={styles.vote}
                        id="voteInput"
                        type="text"
                        onChange={handleOnChange}
                        onKeyDown={handleOnKeyDown}
                        value={num}
                        defaultValue={1}
                    />
                    <span className={`${num === voteNum || !num ? styles.disable : ''} ${styles.add}`} onClick={add}>
                        +
                    </span>
                </div>
                <div className={styles.voteTip}>当前可投票数{voteNum}张</div>
                <div className={`${styles.comfirmVote} ${!num ? 'disable_btn' : 'btn'}`} onClick={handleClick}>
                    确认投票
                </div>
            </div>
        </Modal>
    );
};

Vote.propTypes = {
    voteNum: PropTypes.number,
    onClose: PropTypes.func,
    doGo: PropTypes.func,
};

export default Vote;
